
<app-checklist-list type="receiptform"></app-checklist-list>
